import { ALargeSmall } from "lucide-react";

import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger
} from "@/components/ui/dropdown-menu";

import { useDensity } from "../DensityProvider";
import { DENSITY_DESCRIPTIONS, DENSITY_LABELS } from "../labels";
import { isDensityPreference, DENSITY_PREFERENCES } from "../types";

type Props = {
  /** Classes shared with the sibling account-menu rows. */
  itemClassName: string;
  iconClassName: string;
  /** Controlled open state of the submenu, so the account menu can expand it on request. */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

/** Account-menu row: the current density, muted, before the chevron; Comfortable / Compact inside. */
export function DensityRow({
  itemClassName,
  iconClassName,
  open,
  onOpenChange
}: Props) {
  const { density, setDensity } = useDensity();
  return (
    <DropdownMenuSub open={open} onOpenChange={onOpenChange}>
      <DropdownMenuSubTrigger
        className={itemClassName}
        data-testid="menu-display-density"
      >
        <ALargeSmall className={iconClassName} />
        <span className="flex-1">Display</span>
        <span className="text-sm text-fg-3">{DENSITY_LABELS[density]}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="min-w-56">
        <DropdownMenuRadioGroup
          value={density}
          onValueChange={(value) => {
            if (isDensityPreference(value)) setDensity(value);
          }}
        >
          {DENSITY_PREFERENCES.map((value) => (
            <DropdownMenuRadioItem
              key={value}
              value={value}
              className={`${itemClassName} h-auto items-start py-1.5 pr-8`}
            >
              <span className="grid gap-0.5">
                <span>{DENSITY_LABELS[value]}</span>
                <span className="text-sm text-fg-3">
                  {DENSITY_DESCRIPTIONS[value]}
                </span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
